import { useState } from "react";
import { Menu, X } from "lucide-react";
import { scrollToSection } from "@/App";

const LINKS = [
  { label: "Portfolio", href: "#maisons" },
  { label: "Contact", href: "#inquiries" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    scrollToSection(href);
  };

  return (
    <header
      data-testid="site-nav"
      className="fixed top-0 inset-x-0 z-50 bg-[#F9F8F5]/90 backdrop-blur-md border-b border-ink/10"
    >
      <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
        <a
          href="#top"
          onClick={(e) => go(e, "#top")}
          data-testid="brand-wordmark"
          className="font-cinzel text-sm sm:text-base tracking-[0.25em] text-ink"
        >
          HAILEY <span className="text-bronze">&amp;</span> CHLOE
        </a>

        <nav className="hidden sm:flex items-center gap-8" data-testid="nav-links">
          {LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => go(e, link.href)}
              data-testid={`nav-link-${link.label.toLowerCase()}`}
              className="text-sm text-mutedink hover:text-oxblood transition-colors duration-300"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <button
          data-testid="mobile-menu-btn"
          onClick={() => setOpen(!open)}
          className="sm:hidden text-ink p-1"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <nav
          data-testid="mobile-menu"
          className="sm:hidden border-t border-ink/10 bg-[#F9F8F5] px-6 py-4 flex flex-col gap-4"
        >
          {LINKS.map((link, i) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => go(e, link.href)}
              data-testid={`mobile-nav-link-${i}`}
              className="text-base text-ink"
            >
              {link.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
};
